export const MAX_NO_OF_FOCUS_SKILLS = 3
